import { createAsyncThunk, createSlice, } from "@reduxjs/toolkit";
import { RootState } from "../../../Redux/store";
import { SellAThon } from "../../../Types/SellAThon";

interface FecthSellAThonArgs {
	username?: string | null;
	branchId?: string | null;
};

export const getSellAThon = createAsyncThunk<SellAThon[], FecthSellAThonArgs, { state: RootState, rejectValue: string }>(
	'sales/getSellAThon',
	async (args, { getState, rejectWithValue }) => {
		try {
			const params = new URLSearchParams();

			if (args?.username) params.append('username', args.username);
			if (args?.branchId) params.append('branchId', args.branchId);

			const salesUrl = `https://customer.hirsch.com/account/v2/employee/sellathon?${params.toString()}`;
			const token = getState().auth.token

			if (!token) return rejectWithValue('No Token Found')

			const response = await fetch(salesUrl, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': btoa(`Bearer ${token}`)
				}
			})

			if (!response.ok) throw new Error('Failed to fetch')

			const json = await response.json()
			if (!json.ack) throw new Error(json.errorMessage);
			// console.log(json.data.weeks)
			return json.data
		} catch (err: any) {
			console.error('SellAThon Error:', err)
			return rejectWithValue(err.message)
		}
	}
);

interface salesState {
	salesArr: SellAThon[];
	loading: boolean;
	error: string | undefined | boolean | null;
}

const initialState: salesState = {
	salesArr: [],
	loading: false,
	error: null,
}

const sellAThonSlice = createSlice({
	name: 'sellAThon',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getSellAThon.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getSellAThon.fulfilled, (state, action) => {
				state.loading = false;
				state.salesArr = action.payload
				state.error = null;
			})
			.addCase(getSellAThon.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload || 'Failed to fetch sales data';
			});
	},
});

export const sellAThonReducer = sellAThonSlice.reducer;
